/** Supported UI languages — must match Transloco `availableLangs`. */
export type SaiLang = 'en' | 'ar';

export function normalizeSaiLang(value: unknown): SaiLang | null {
    return value === 'ar' || value === 'en' ? value : null;
}

/**
 * Read the persisted UI language at bootstrap. Prefers `prefLang` (backend mirror) and
 * falls back to the legacy `language` key written by the language switcher.
 */
export function getPersistedSaiLang(): SaiLang {
    try {
        if (typeof localStorage === 'undefined') {
            return 'en';
        }
        const fromPref = normalizeSaiLang(localStorage.getItem('prefLang'));
        if (fromPref) {
            return fromPref;
        }
        return localStorage.getItem('language') === 'ar' ? 'ar' : 'en';
    } catch {
        return 'en';
    }
}

/** Keep `language` (runtime / x-lang header) and `prefLang` (backend mirror) in sync. */
export function persistSaiLang(lang: SaiLang): void {
    localStorage.setItem('language', lang);
    localStorage.setItem('prefLang', lang);
}

export function applyDocumentLanguage(lang: SaiLang): void {
    if (typeof document === 'undefined') {
        return;
    }
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
}
